export const VERIFIABLE_SUBFOLDER_SLUGS = [
  "official-id",
  "constitutive-act",
  "proof-of-address",
  "proof-of-income",
  "escrituras-predial",
];
